import withErrorGuard from 'components/core/withErrorGuard';
import { VideoObject as VideoObjectComponent } from './VideoObject';

export const VideoObject = withErrorGuard()(VideoObjectComponent);

export default VideoObject;
